"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GridItemView = function GridItemView(props) {
  var item = props.item;
  var imageStyle = {
    backgroundImage: "url(".concat(item.image, ")")
  };
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: "file-link",
    id: item.id,
    target: "_self",
    href: item.url,
    onClick: function onClick(e) {
      props.onItemClick.apply(null, [e, item]);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image",
    style: imageStyle
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "title"
  }, item.name));
};

GridItemView.propTypes = {
  onItemClick: _propTypes["default"].func.isRequired,
  item: _propTypes2["default"].item.isRequired
};
var _default = GridItemView;
exports["default"] = _default;